export default __webpack_public_path__ + "1f2e04934ae9c55af4781075913c4055.jpg";